export default __webpack_public_path__ + "static/media/spark_58.b2ecb2ad.png";